import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { checkNameShowHide, nameMask } from '../../utils/utils';
import { listenChatMembers, listenUnreadCount } from "../../services/chatService";

// 🔹 Small Sub-component for the count badge
const UnreadBadge = ({ chatId, currentUserId }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!chatId || !currentUserId) {
      setCount(0);
      return;
    }

    const unsubscribe = listenUnreadCount(
      chatId,
      currentUserId,
      (cnt) => setCount(Number(cnt) || 0)
    );

    console.log("Unread listener attached:", chatId);

    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
        
      }
    };
  }, [chatId, currentUserId]);
  
  return count > 0 ? (
    <span className="badge rounded-pill bg-danger">{count}</span>
  ) : null;
};


export default function RightSideChatList({ planDetailUser, formData }) {
  const selfProfileId = formData?.profile_id;
  
  const navigate = useNavigate();

  // chat list
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!selfProfileId) return;
    const unsub = listenChatMembers(selfProfileId, (data) => {
      setMembers(data);
      setLoading(false);
    });
    return () => unsub && unsub();
  }, [selfProfileId]);

  const handleChatClick = (e, profileId) => {
    e.preventDefault();
    if (!profileId) {
      alert('User ID missing');
      return;
    }
    navigate(`/chat-box/${profileId}`);
  };

  if (loading) return <p>Loading Chat...</p>;

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 ps-lg-0">
          <div className="chat-window">
            <p>
              <strong>Chat Window</strong>
            </p>
          </div>
          <div className="profilelist-rightpanle">

            {members.length === 0 && <p className="p-3 text-muted">No conversations yet</p>}

            {members.map((m) => {
              // Skip self-chat if necessary
              // if (m.chatId === `${CURRENT_USER_ID}_${selfProfileId}` || m.chatId === `${selfProfileId}_${CURRENT_USER_ID}`) {
              //   return null;
              // }

              const time = m.lastMessageTime
                ? new Date(Number(m.lastMessageTime)).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })
                : "";

              return (
                <>
                <div className="col-12" key={m.chatId}>
                  <Link to="#" onClick={(e) => handleChatClick(e, m?.primary_id)}>
                    <div className="man-chat d-flex pt-2  align-items-center">

                      <div className="manimg-chat d-flex align-items-center flex-grow-1">
                        <div className="img-caht-sec" style={{ marginRight: '0px' }}>
                          <img src={m.image || '/assets/img/images-mes-2.jpg'} alt="user" className="rounded-circle" style={{ width: '30px', height: '30px', objectFit: 'cover' }} />
                        </div>

                        <div className="caht-clint-name" style={{ marginRight: '0px' }}>
                          <h6 className="mb-0" style={{ fontSize: '12px' }}>{m.name}</h6>
                          <p className="mb-0 text-truncate" style={{ maxWidth: '180px', fontSize: '11px' }}>
                            {m.about || "No messages yet"}
                          </p>
                        </div>
                      </div>

                      <div className="caht-time text-end">
                        <UnreadBadge chatId={m.chatId} currentUserId={selfProfileId} />
                        <p className="mb-1" style={{ fontSize: '12px' }}>{time}</p>
                        
                      </div>

                    </div>
                  </Link>
                </div>
                </>
              );
            })}


          </div>
        </div>
      </div>
    </>
  )
}

